import React from 'react';

import { Checkbox } from 'antd';

import { useRecordContext } from './Context';

function SelectAll() {
  const { isAllRecords, toggleCurrentAllRecords } = useRecordContext();

  return (
    <Checkbox
      checked={isAllRecords}
      onChange={toggleCurrentAllRecords}
    />
  );
}

export default SelectAll;
